// import React from 'react';
// import Slider from 'react-slick';

// // The Testimonials component takes `testimonials` and `title` as props
// const Testimonials = ({ testimonials, title = "Love from our Clients" }) => {

//   // Slick slider settings for auto sliding
//   const settings = {
//     dots: true,               // Show dots for navigation
//     infinite: true,           // Infinite looping
//     speed: 500,               // Speed of sliding (in ms)
//     autoplay: true,           // Enable auto sliding
//     autoplaySpeed: 3000,      // Time delay between auto slides (in ms)
//     slidesToShow: 2,          // Show two slides at once
//     slidesToScroll: 1,        // Scroll one slide at a time
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2, // Show 2 slides on medium and larger screens
//         },
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1, // Show 1 slide on small screens (tablets or smaller)
//         },
//       },
//     ],
//   };

//   return (
//     <section className="testimonial-style-two white-bg py-3 centred">
//       <div className="auto-container">
//         <div className="sec-title mb_50">
//           <span className="sub-title">Testimonials</span>
//           <h2>{title}</h2>
//         </div>
//         <Slider {...settings} className="three-item-carousel owl-carousel owl-theme owl-nav-none">
//           {testimonials.map((testimonial, index) => (
//             <div key={index} className="testimonial-block-two">
//               <div className="inner-box">
//                 {/* <figure className="thumb-box">
//                   <img src={testimonial.image} alt={testimonial.name} />
//                 </figure> */}
//                 <h3>{testimonial.name}</h3>
//                 {/* <span className="designation">{testimonial.designation}</span> */}
//                 <ul className="rating">
//                   {testimonial.rating.map((star, index) => (
//                     <li key={index}>
//                       <img src="/images/icons/icon-1.png" alt={`star-${index}`} />
//                     </li>
//                   ))}
//                 </ul>
//                 <p>{testimonial.text}</p>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;



import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function Testimonialsabout({ testimonials }) {
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ]
  };

  return (
    <section className="testimonials-section" style={{ padding: '40px 0', background: '#f8f9fa' }}>
      <div className="container">
        <div className="heading-block" style={{ textAlign: 'center', marginBottom: 30 }}>
          <div className="sub-title" style={{ color: '#F47C7C', fontWeight: 'bold' }}>Testimonials & Reviews</div>
          <h2 className="title">What They’re Saying</h2>
        </div>

        <Slider {...settings}>
          {testimonials.map((t, i) => (
            <div key={i} style={{ padding: 15 }}>
              <div style={{
                background: '#fff',
                padding: 20,
                borderRadius: 12,
                boxShadow: '0 4px 10px rgba(0,0,0,0.06)',
                textAlign: 'center',
                height: '100%'
              }}>
                <div style={{ color: '#FFA500', marginBottom: 10 }}>
                  {t.rating.map((_, i) => (
                    <i key={i} className="fas fa-star"></i>
                  ))}
                </div>
                <p style={{ fontStyle: 'italic', margin: '15px 0' }}>{t.text}</p>
                <strong className='darkcolor'>{t.name}</strong><br />
                <span>{t.designation}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
